export const camelCaseToSpacesRegEx = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
